@if (loadError) {
  <div class="landing-error">
    Landing page failed to load.
  </div>
} @else {
  <div class="landing-root" [innerHTML]="landingMarkup"></div>
}
